

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ListinoNazionale } from "src/app/models/listinoNazionale.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";


@Component({
  templateUrl: "./dialog-storico-listino.component.html",
  styleUrls: ["../listino.component.css"],
})
export class StoricoListinoComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  
  protected isLoadingStoricoListino:Boolean = false;
  protected storicoListino:Listino[] = [];
  protected currentListino:Listino;
  protected listino:Listino;
  protected regione:string;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public stiliService:StiliService,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
    private utilService:UtilService,

  ) {
    this.listino  = this.config.data.listino;
    this.regione = this.config.data.regione;
  }

  ngOnInit(): void {
      this.loadStorico();
  }

  
  loadStorico(){
    this.isLoadingStoricoListino = true;
    this.listiniService.getStorico(this.listino.id.toString()).subscribe( {
      next: (res) => {
       res.forEach(listino => {
          if(this.regione === 'LIGURIA'){
            this.logger.info(listino);
            if(listino.liguria1 || listino.liguria2 || listino.liguria3 || listino.liguria4 || listino.liguria5){
              this.logger.info('lo fa');

              this.storicoListino.push(listino);
            }
          }else if(this.regione === 'PIEMONTE'){
            if(listino.piemonte1 || listino.piemonte2 || listino.piemonte3 || listino.piemonte4 || listino.piemonte5){
              this.storicoListino.push(listino);
            }
          }else if(this.regione === 'SARDEGNA'){
            if(listino.sardegna1 || listino.sardegna2 || listino.sardegna3 || listino.sardegna4 || listino.sardegna5){
              this.storicoListino.push(listino);
            }
          }
        });
        this.logger.info(this.storicoListino);
        this.isLoadingStoricoListino = false;
      },
      error: (e) => {
        this.logger.info(e);
        this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di caricamento dello storico del listino'});
    },
      complete: () => {
      }
  });
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      
          this.dialogRef.close({ success: true });
       
    
    }
  }
}
